import { STATUSES, STATUS_DESC } from "../lib/constants";
import { Check } from "lucide-react";

export default function Timeline({ status }) {
  // « Non retenu » est un état terminal : la frise s'arrête à « Idée déposée » et
  // n'affiche pas les étapes suivantes comme atteintes.
  const current = status === "NON RETENU PAR NOS ÉQUIPES" ? STATUSES.indexOf("IDÉE DÉPOSÉE") : STATUSES.indexOf(status);
  const steps = STATUSES.filter((s) => s !== "BROUILLON" && s !== "NON RETENU PAR NOS ÉQUIPES");

  return (
    <div className="relative pl-8" data-testid="project-timeline">
      <div className="absolute left-[11px] top-2 bottom-2 w-px bg-white/10" />
      <div
        className="absolute left-[11px] top-2 w-px bg-gradient-to-b from-cyan to-electric transition-all"
        style={{ height: `${Math.max(0, (current - 1)) / (steps.length - 1) * 100}%` }}
      />
      <div className="space-y-5">
        {steps.map((s) => {
          const idx = STATUSES.indexOf(s);
          const done = idx < current;
          const active = idx === current;
          return (
            <div key={s} className="relative">
              <span
                className={`absolute -left-8 top-0.5 flex h-6 w-6 items-center justify-center rounded-full border text-[10px] transition-all ${
                  active ? "border-cyan bg-cyan text-void glow-cyan"
                  : done ? "border-cyan/40 bg-cyan/10 text-cyan"
                  : "border-white/15 bg-void text-ink-tertiary"
                }`}
              >
                {done ? <Check size={12} /> : ""}
              </span>
              <div className={active ? "text-white" : done ? "text-ink-secondary" : "text-ink-tertiary"}>
                <div className={`text-sm font-600 uppercase tracking-wide ${active ? "text-cyan" : ""}`}>{s}</div>
                {active && <div className="mt-0.5 text-xs text-ink-secondary">{STATUS_DESC[s]}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
